export default "__VITE_PUBLIC_ASSET__8b858de7__"